import React from "react";
import { createPortal } from "react-dom";
import { useSelector } from "react-redux";

import RewardAlert from "../rewardAlert/RewardAlert";
import TransferAlert from "../transferAlert/TransferAlert";
import "./ModalPortal.scss";
import "styles/common/font/nanumsquareround.css";
import "styles/common/font/nanumsquareround.min.css";

const MODAL_COMPONENTS = {
    reward: RewardAlert,
    transfer: TransferAlert,
};

const ModalPortal = () => {
    const modalData = useSelector((state) => state.modalReducer);
    const { type, props } = modalData;

    const selectedElement = document.querySelector("#modal-root");
    if (selectedElement === null) return <div></div>;

    if (!type) return null;
    const Modal = MODAL_COMPONENTS[type];

    return createPortal(
        <div className="backdrop">
            <Modal {...props} />
        </div>,
        selectedElement,
    );
};

export default ModalPortal;
